/**
 * Wire contract for POST /v2/selections/validate and /apply.
 * 1:1 mirror of geo-services hbp-user com.harrispoll.brandplatform.user.selections DTOs.
 */

export type CheckStatus =
  | "OWNED"
  | "ACCESSIBLE"
  | "ALREADY_HAVE"
  | "ELIGIBLE"
  | "NOT_ELIGIBLE";

export type BrandSetIneligibleReason =
  | "NOT_FOUND"
  | "INVALID_ID"
  | "MEMBERS_NOT_ACCESSIBLE";

export type SegmentIneligibleReason =
  | "NOT_FOUND"
  | "INVALID_ID"
  | "DEACTIVATED"
  | "SUPERSEDED"
  | "FILTERS_NOT_ACCESSIBLE"
  | "NOT_APPLICABLE_IN_YOUR_MARKETS";

export type ApplyOutcome = "CREATED" | "ALREADY_HAVE" | "OWNED" | "ACCESSIBLE";

export type SelectionsErrorCode =
  | "INVALID_REQUEST"
  | "APPLY_CONFLICT"
  | "FEATURE_DISABLED";

export interface FilterRefInput {
  code: string;
  options?: string[];
}

export interface SelectionsValidateRequest {
  brands?: number[];
  brandSets?: string[];
  filters?: FilterRefInput[];
  segments?: string[];
}

export interface BrandCheck {
  id: number;
  accessible: boolean;
  name?: string;
}

export interface OptionCheck {
  code: string;
  accessible: boolean;
  label?: string;
}

export interface FilterCheck {
  code: string;
  accessible: boolean;
  label?: string;
  options?: OptionCheck[];
}

export interface BrandSetCheck {
  ulid: string;
  status: CheckStatus;
  reason?: BrandSetIneligibleReason;
  name?: string;
  memberCount?: number;
  memberNames?: string[];
  inaccessibleMemberNames?: string[];
  existingUlid?: string;
}

export interface SegmentCheck {
  code: string;
  status: CheckStatus;
  reason?: SegmentIneligibleReason;
  label?: string;
  filterLabels?: string[];
  inaccessibleFilterLabels?: string[];
  existingCode?: string;
}

export interface SelectionsValidateResponse {
  brands: BrandCheck[];
  brandSets: BrandSetCheck[];
  filters: FilterCheck[];
  segments: SegmentCheck[];
}

export interface SelectionsApplyRequest {
  brandSets?: string[];
  segments?: string[];
}

export interface ApplyMapping {
  source: string;
  result: string;
  outcome: ApplyOutcome;
}

export interface SelectionsApplyResponse {
  brandSets: ApplyMapping[];
  segments: ApplyMapping[];
}

export interface ConflictItem {
  type: "BRAND_SET" | "SEGMENT";
  id: string;
  reason?: string;
}

export interface SelectionsErrorBody {
  code: SelectionsErrorCode;
  message: string;
  items?: ConflictItem[];
}

/** Server-enforced caps. brands + brandSets share the 200 budget; filters/segments are 50 each. */
export const SELECTIONS_CAPS = {
  brandsAndBrandSets: 200,
  filters: 50,
  segments: 50,
} as const;
